import { DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslocoModule } from '@jsverse/transloco';
import { GroupSelectOption } from '@rma/generic/ui/forms/group-select';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { SkeletonComponent } from '@rma/generic/ui/skeleton';
import { TrixelComponent, TrixelSourceCategories } from '@rma/generic/ui/trixels';
import { ShortNumberPipe } from '@rma/generic/util/pipes/short-number';
import { BrandedHeaderComponent } from '@rma/profiles/public/ui-branded-header';
import { ReviewTileListComponent } from '@rma/reviews/public/ui-review-tile-list';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FindMyAgentResponseVM, OVERALL_LOCATION_ID, Statistic } from '../../domain/results';
import { MapsComponent } from '../../ui-maps-landing/maps.component';
import { ResultAttributionComponent } from '../ui-attribution/attribution.component';
import { BadgesComponent } from '../ui-badges/badges.component';
import { ResultContactComponent } from '../ui-contact/contact.component';
import { PriceExpectationComponent } from '../ui-price-expectation/price-expectation.component';
import { ResultProfileComponent } from '../ui-profile/profile.component';

@Component({
  selector: 'rma-result',
  imports: [
    BadgesComponent,
    BrandedHeaderComponent,
    DecimalPipe,
    MapsComponent,
    MatButtonModule,
    MatButtonToggleModule,
    NgScrollbarModule,
    NgTemplateOutlet,
    PriceExpectationComponent,
    ReactiveFormsModule,
    ResultAttributionComponent,
    ResultContactComponent,
    ResultProfileComponent,
    ReviewTileListComponent,
    RmaIconComponent,
    ShortNumberPipe,
    SkeletonComponent,
    TranslocoModule,
    TrixelComponent,
  ],
  templateUrl: './result.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultComponent implements OnChanges {
  @Input()
  agent!: FindMyAgentResponseVM;

  @Input()
  locality!: GroupSelectOption;

  @Input()
  activeLocality = OVERALL_LOCATION_ID;

  @Input()
  showActivity = false;

  @Input()
  showAttribution = false;

  @Output()
  seletedLocality = new EventEmitter<string | undefined>();

  @Output()
  showHideActivity = new EventEmitter<boolean>();

  @Output()
  loadLatestReview = new EventEmitter<void>();

  @Output()
  contact = new EventEmitter<void>();

  readonly trixelsSourceCategory = TrixelSourceCategories.FindMyAgentResultsView;
  readonly localityControl = new FormControl<string>(OVERALL_LOCATION_ID);
  readonly overallValue = OVERALL_LOCATION_ID;
  stats: Statistic[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeLocality']) {
      this.localityControl.setValue(this.activeLocality, { emitEvent: false });
      this.stats = this.activeLocality === OVERALL_LOCATION_ID ? this.agent.overallStatistics : this.agent.locationStatistics;
    }
  }

  onShowHideActivity(showActivity: boolean) {
    this.showHideActivity.emit(showActivity);

    if (!this.agent.latestReviews) {
      this.loadLatestReview.emit();
    }
  }
}
